import { PropertyMapping } from './property-mapping';
import { PropertyMappingBuilderImpl } from './property-mapping-builder-impl';
export function propertyMapping(create) {
    var builder = new PropertyMappingBuilderImpl();
    var builderMapping = create(builder);
    return new PropertyMapping(builderMapping);
}
//# sourceMappingURL=property-mapping-builder-factory.js.map